export default __webpack_public_path__ + "static/media/esignature.1fd11083.svg";